import gql from 'graphql-tag';
import apolloClient from '../apollo';
import { accessLevelOf } from '../helpers/accessLevel';

/** Level of every node while the organization switch is off: the matrix does not restrict. */
const UNRESTRICTED_LEVEL = 'editor';

const getDefaultState = () => ({
  accessNodes: [],
  isLoaded: false,
  hasError: false,
});

const state = getDefaultState();

const actions = {
  /** Loads the catalog nodes the user may see; on error only the flag is set, no retry. */
  async fetchMyAccess({ commit }) {
    try {
      const response = await apolloClient.query({
        query: gql`
          query myAccess {
            myAccess {
              id
              parent
              viewId
              kind
              labelKey
              level
            }
          }
        `,
        fetchPolicy: 'network-only',
      });
      commit('SET_MY_ACCESS', response.data.myAccess);
    } catch (error) {
      console.error('fetchMyAccess failed, the old navigation stays', error);
      commit('SET_MY_ACCESS_ERROR');
    }
  },

  /** Called after a matrix save, so the new navigation follows the change at once. */
  async refreshMyAccess({ dispatch }) {
    await dispatch('fetchMyAccess');
  },

  /** Called on logout, so the next user never sees the access of the previous one. */
  resetMyAccess({ commit }) {
    commit('RESET_MY_ACCESS');
  },
};

const mutations = {
  /** Own name: modules are not namespaced, SET_DEFAULT_STATE would reset other modules too. */
  RESET_MY_ACCESS(state) {
    Object.assign(state, getDefaultState());
  },
  SET_MY_ACCESS(state, accessNodes) {
    state.accessNodes = accessNodes || [];
    state.isLoaded = true;
    state.hasError = false;
  },
  SET_MY_ACCESS_ERROR(state) {
    state.accessNodes = [];
    state.isLoaded = false;
    state.hasError = true;
  },
};

const getters = {
  getMyAccessNodes: (state) => state.accessNodes,
  isMyAccessLoaded: (state) => state.isLoaded,
  hasMyAccessError: (state) => state.hasError,
  /** Switch off: editor everywhere; on: level from `myAccess`, null if the node is not visible. */
  getAccessLevel: (state, getters, rootState, rootGetters) => (nodeId) =>
    rootGetters['auth/isOrganizationRoleNavigationEnabled']
      ? accessLevelOf(state.accessNodes, nodeId)
      : UNRESTRICTED_LEVEL,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
